export default __webpack_public_path__ + "static/media/u3.1e28fe0b.svg";